import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent, Grid, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography, AppBar, Toolbar, Button } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const styles = theme => ({
    lessonCard: {
        height: '400px',
        overflow: 'auto',
        padding: '0px',
    },
    eventCard: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        paddingLeft: '8px',
        paddingRight: '8px',
    }
});

class InstructorSelfPacedCourseDashboard extends Component {

    state = {
        listIndexStart: 0,
        activeListItem: 0
    }

    handleArrowClick = (dir) => {
        const curIndex = this.state.listIndexStart
        if (dir === 'down') {
            return this.setState({ listIndexStart: curIndex - 3 })
        }
        return this.setState({ listIndexStart: curIndex + 3 })
    }

    getCardStyle = (color) => {
        return {
            borderRadius: 4,
            borderWidth: 2,
            borderColor: color,
            width: '100%',
        }
    }

    getToolTipContent = (event) => {
        const { StudentCount } = this.props;
        const graded = event.StudentSubmissions.filter(e => e.IsGraded === 1).length;
        const waiting = event.StudentSubmissions.filter(e => e.IsGraded === 0).length;

        let statusIcon;
        if (moment(event.EndTime) > moment()) {
            return null
        }
        else if (graded === StudentCount) {
            statusIcon = <CheckIcon />
        }
        else if (waiting > 0) {
            statusIcon = <Icon>warning</Icon>
        }
        else {
            statusIcon = null
        }
        return (
            <Tooltip className="float-right"
                title={
                    <React.Fragment>
                        <div>Outstanding: {StudentCount - event.StudentSubmissions.length}</div>
                        <div>To be Graded: {waiting}</div>
                        <div>Graded: {graded}</div>
                    </React.Fragment>}
                enterDelay={500}
            >
                <div className="flex items-center">
                    {statusIcon}
                </div>
            </Tooltip>
        )

    }

    handleListItemClick = (event) => {
        return this.props.history.push(`/grade/student/list/` + event.company_calendar_event_id)
    }

    getLessonCard = (lesson_info, i) => {
        const { classes, unavailableToClick } = this.props;
        const { listIndexStart } = this.state;

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography color={"inherit"}>Lesson {listIndexStart + 1 + i}: {lesson_info.LessonName}</Typography>
                    </Toolbar>
                </AppBar>
                <Card>
                    <CardContent className={classes.lessonCard}>
                        <List
                            disablePadding={true}
                        >
                            {lesson_info.EventList.map((event_info, event_index) => {
                                return (
                                    <ListItem key={event_index}>
                                        <Card
                                            style={this.getCardStyle(event_info.EventColor)}
                                        >
                                            <CardContent className={classes.eventCard}>
                                                <Button
                                                    onClick={() => this.handleListItemClick(event_info)}
                                                    style={{ textTransform: "none" }}
                                                >
                                                    {event_info.EventName}
                                                </Button>
                                                {this.getToolTipContent(event_info)}
                                            </CardContent>
                                        </Card>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

    render() {
        const { events, StudentCount } = this.props
        const { listIndexStart } = this.state;

        return (

            <Grid container spacing={8}>
                <Grid item xs={1}>
                    <IconButton
                        onClick={() => this.handleArrowClick('down')}
                        disabled={listIndexStart === 0}
                    >
                        <Icon style={{ fontSize: '50px' }}>arrow_back</Icon>
                    </IconButton>
                </Grid>
                <Grid item xs={10}>
                    <Grid container spacing={8}>
                        {events.slice(listIndexStart, listIndexStart + 3).map((lesson, i) => {
                            return (
                                <Grid item xs={4} key={lesson.company_calendar_day_id}>
                                    {this.getLessonCard(lesson, i)}
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        onClick={() => this.handleArrowClick('up')}
                        disabled={listIndexStart + 4 > events.length}
                    >
                        <Icon style={{ fontSize: '50px' }}>arrow_forward</Icon>
                    </IconButton>
                </Grid>
            </Grid>

        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, null)(InstructorSelfPacedCourseDashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/InstructorSelfPacedCourseDashboard.js